import { useEffect } from 'react';

import { di } from 'react-magnetic-di';

import { useAIMateExperienceTracker } from '../../controllers/experience-tracker';
import { type ExperienceNameType } from '../../controllers/experience-tracker/constants';

type ExperienceProps = {
	name: ExperienceNameType;
};

export const ExperienceSuccess = ({ name }: ExperienceProps) => {
	di(useAIMateExperienceTracker);

	const experienceTracker = useAIMateExperienceTracker();

	useEffect(() => {
		experienceTracker.succeed({
			name,
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return null;
};

export const ExperienceFailure = ({ error, name }: ExperienceProps & { error: Error }) => {
	di(useAIMateExperienceTracker);

	const experienceTracker = useAIMateExperienceTracker();

	useEffect(() => {
		experienceTracker.fail({
			name,
			error,
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return null;
};

export const ExperienceStart = ({ name }: ExperienceProps) => {
	di(useAIMateExperienceTracker);

	const experienceTracker = useAIMateExperienceTracker();

	useEffect(() => {
		experienceTracker.start({
			id: name,
			name,
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return null;
};
